import React from 'react';
import CloseIcon from 'mdi-react/CloseIcon';
import { Typography } from '@material-ui/core';
import Row from 'components/Row';
import { ModalCard } from 'components/Modal';
import { PrimaryButton } from 'components/Buttons/PrimaryButton';

export default function LoginAlertModal(props) {
  return (
    <React.Fragment>
      <ModalCard>
        <Row justify="space-between">
          <Typography variant="h4">Oops!!</Typography>
          <CloseIcon style={{ cursor: 'pointer' }} onClick={props.onClick} />
        </Row>
        <br />
        <Typography>You need to Login or Sign up</Typography>
        <br />
        <PrimaryButton
          onClick={() => {
            props.history.push('/login');
          }}
          small
        >
          Goto Login
        </PrimaryButton>
      </ModalCard>
    </React.Fragment>
  );
}
